// Material UI
import { makeStyles } from '@material-ui/core/styles'
// Consts
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  box: {
    alignItems: 'center',
    border: `solid 1px ${Colors.DISABLED_COLOR}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 4px 5px 16px',
    whiteSpace: 'pre-wrap',
  },
  price: {
    color: Colors.SECONDARY_FONT_COLOR,
    marginLeft: 'auto',
    marginRight: 16,
  },
  titleContainer: {
    color: Colors.SECONDARY_FONT_COLOR,
    marginBottom: 10,
    whiteSpace: 'pre-wrap',
  },
  infoContainer: {
    width: '30vw',
  },
  generalOrder: {
    order: 1,
  },
  customOrder: {
    order: 1,
    [theme.breakpoints.down('xs')]: {
      order: 2,
      alignItems: 'flex-start',
    },
  },
  toggleSwitch: {
    alignItems: 'flex-end',
  },
}))
